import { render, staticRenderFns } from "./Moves.vue?vue&type=template&id=1adeda05&"
import script from "./Moves.vue?vue&type=script&lang=ts&"
export * from "./Moves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports